<template>
    <div>
        <v-dialog v-model="mostrar" max-width="600px">
            <v-card>
                <v-card-title>
                <span class="headline">Subir Archivo</span>
                </v-card-title>
                <v-card-text>
                <v-container>
                    <v-row>
                        <v-col>
                            <v-file-input
                            id="input_archivo"
                            v-model="archivo" 
                            label="Seleccione Archivo" 
                            accept=".jpg, .png"
                            outlined 
                            dense>
                            </v-file-input>
                        </v-col>
                        <v-col>
                            <v-btn color="green darken-1" @click="subirArchivo"><v-icon>publish</v-icon></v-btn>
                        </v-col>
                    </v-row>
                </v-container>
                </v-card-text>
                <!-- <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
                <v-btn color="blue darken-1" text @click="dialog = false">Save</v-btn>
                </v-card-actions> -->
            </v-card>
            </v-dialog>
    </div>
</template>
<script>
import {mapState,mapMutations} from 'vuex';
export default {
    data:()=>({
        archivo:null,
        configuracion:{},
        mostrar:false
    }),
    mounted(){
        this.$parent.$on('abrir_subir_archivo',(conf)=>{
            this.configuracion = conf;
            this.mostrar = true;
        });
    },
    methods: {
        async subirArchivo(){
            if(this.archivo){
                //this.mostrarLoading('Subiendo Archivo...');
            this.mostrarLoading({titulo:'Subiendo Archivo...',color:'green'})

                //subiendo el archivo
                let token = this.headers.headers['Authorization'];
                let cabecera = {
                    headers:{
                        'Authorization':token,
                        'Content-Type':'multipart/form-data'
                    }
                }
                // cabecera['headers']['Content-Type']='multipart/form-data';
                let body = new FormData();
                body.append('archivo', this.archivo);
                // console.log('headers',cabecera);
                await this.axios.post(this.configuracion.ruta, body, cabecera).then((res) =>{
                    this.$emit('archivo_subido',res);
                }).catch((error) =>{
                    console.log('error',error);
                    this.ocultarLoading();
                });
            }
        },

        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url','headers'])
    },
}
</script>